import { r as registerInstance, h, g as getElement, c as createEvent } from './index-16dc7dde.js';
import { n as noop_1 } from './noop-9247c8ef.js';
import { c as classnames } from './index-136476ff.js';
import './_commonjsHelpers-ba3f0406.js';

const sectionHeaderCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.section-heading{font-weight:700;margin:0}@media screen and (max-width: 979px){.section-heading{font-size:16px;line-height:25px}}@media screen and (min-width: 980px){.section-heading{font-size:28px;line-height:30px}}.section-heading--color-default{color:#3dcd58}.section-heading--color-inherit{color:inherit}";

let SectionWithHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.color = 'default';
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("h2", { class: `section-heading section-heading--color-${this.color}`, onClick: noop_1 }, h("slot", null)));
  }
  get el() { return getElement(this); }
};
SectionWithHeader.style = sectionHeaderCss;

const viewMoreLinkCss = ":host{display:inline-block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.view-more-link{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;color:#42b4e6;font-weight:400}@media screen and (max-width: 979px){.view-more-link{font-size:14px;line-height:20px;margin-top:24px}}@media screen and (min-width: 980px){.view-more-link{font-size:18px;line-height:28px;margin-top:20px}}.view-more-link:focus{outline:auto}.view-more-link:hover .view-more-link__text{text-decoration:underline}.view-more-link__icon{display:inline-block;vertical-align:middle}:host(:not([dir=\"rtl\"])) .view-more-link__icon--rotated{transform:rotate(180deg)}:host([dir=\"rtl\"]) .view-more-link__icon--rotated{transform:rotate(-180deg)}";

let ViewMoreLink = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didToggleViewMore = createEvent(this, "didToggleViewMore", 7);
    this.handleClick = () => this.didToggleViewMore.emit(!this.isExpanded);
  }
  render() {
    const [text, icon] = [
      this.isExpanded ? this.viewLessLabel : this.viewMoreLabel,
      ViewMoreLink.icons.DOWN,
    ];
    const iconClasses = classnames({
      'view-more-link__icon': true,
      'view-more-link__icon--rotated': this.isExpanded,
    });
    return (h("button", { class: "view-more-link", onClick: this.handleClick, type: "button" }, [
      h("span", { class: "view-more-link__text" }, text),
      h("pes-icon", { class: iconClasses, size: this.iconSize }, icon),
    ]));
  }
};
ViewMoreLink.icons = {
  UP: 'arrow2_up',
  DOWN: 'arrow2_down',
};
ViewMoreLink.style = viewMoreLinkCss;

export { SectionWithHeader as pes_section_header, ViewMoreLink as pes_view_more_link };
